
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class OtherTable extends Vue {
    //不是游戏的流水行为
    table = {
        data: [],
        column: []
    }
    //注册赠送
    optTabledata2 = [
        { key: 'time', title: '注册日期', align: 'center' },
        { key: 'user_id', title: '玩家ID', align: 'center' },
        {
            key: 'phone',
            title: '绑定手机号',
            align: 'center',
            render: (h, params) => {
                let str = params.row.phone.substr(0, 7) + '****' + params.row.phone.substr(11)
                return h('span', str)
            }
        },
        {
            key: 'chang_point',
            title: '赠送金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //公司入账;银行卡转入
    optTabledata5 = [
        { key: 'time', title: '发放时间', align: 'center' },
        {
            key: 'point',
            title: '转入金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        },
        {
            key: 'opt_source',
            title: '操作员ID',
            align: 'center',
            render: (h, params) => {
                let str = params.row.opt_source
                return h('span', str)
            }
        }
    ]
    //代理业绩佣金
    optTabledata9 = [
        { key: 'time', title: '发放时间', align: 'center' },
        {
            key: 'phone',
            title: '业绩佣金类型',
            align: 'center',
            render: (h, params) => {
                let str = params.row.params.row.opt_code == '9' ? '直属佣金' : '团队佣金'
                return h('span', str)
            }
        },
        {
            key: 'point',
            title: '佣金金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //拒绝转出返还
    optTabledata11 = [
        { key: 'time', title: '拒绝转出时间', align: 'center' },
        {
            key: 'point',
            title: '返还转出金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        },
        { key: 'opt_source', title: '操作员ID', align: 'center' }
    ]
    //转出金额
    optTabledata12 = [
        { key: 'time', title: '发起转出时间', align: 'center' },
        {
            key: 'point',
            title: '转出金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        },
        { key: 'opt_source', title: '操作员ID', align: 'center' }
    ]
    //线上转入
    optTabledata6 = [
        { key: 'time', title: '发放时间', align: 'center' },
        {
            key: 'point',
            title: '转入金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        },
        { key: 'pack_no', title: '转入子商户', align: 'center' }
    ]
    //管理后台赠送
    optTabledata8 = [
        { key: 'time', title: '赠送时间', align: 'center' },
        {
            key: 'point',
            title: '赠送金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        },
        { key: 'opt_source', title: '操作员ID', align: 'center' }
    ]
    //存入银行
    optTabledata17 = [
        { key: 'time', title: '注册日期', align: 'center' },
        { key: 'user_id', title: '玩家ID', align: 'center' },
        {
            key: 'chang_point',
            title: '银行变动金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //税收返佣
    optTabledata20 = [
        { key: 'time', title: '领取时间', align: 'center' },
        {
            key: 'point',
            title: '税收金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        },
        { key: 'opt_source', title: '操作信息', align: 'center' }
    ]
    //任务奖励
    optTabledata29 = [
        { key: 'time', title: '领取时间', align: 'center' },
        {
            key: 'point',
            title: '奖励任务类型',
            align: 'center',
            render: (h, params) => {
                let str = params.row.opt_source.split('-')[0]
                return h('span', str)
            }
        },
        {
            key: 'name',
            title: '任务名称',
            align: 'center',
            render: (h, params) => {
                return h('span', JSON.parse(params.row.opt_detail).name)
            }
        },
        {
            key: 'point',
            title: '奖励金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //金币兑入与兑出
    optTabledata13 = [
        // { key: 'time', title: '外接平台', align: 'center' },
        {
            key: 'game_name',
            title: '外接游戏',
            align: 'center'
        },
        {
            key: 'point',
            title: '兑换金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //活动奖励
    optTabledata22 = [
        // { key: 'time', title: '外接平台', align: 'center' },
        {
            key: 'game_name',
            title: '奖励活动',
            align: 'center',
            render: (h, params) => {
                let str = params.row.opt_source.split(' ')[0] || ''
                return h('span', str)
            }
        },
        {
            key: 'point',
            title: '奖励金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //彩池中奖获得
    optTabledata23 = [
        // { key: 'time', title: '外接平台', align: 'center' },
        {
            key: 'game_name',
            title: '所属子游戏',
            align: 'center'
        },
        {
            key: 'point',
            title: '获得奖金',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //   牌局取消退回
    optTabledata24 = [
        {
            key: 'game_name',
            title: '所属子游戏',
            align: 'center'
        },
        {
            key: 'point',
            title: '退回金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        },
        {
            key: 'opt_detail',
            title: '退回原因',
            align: 'center'
        }
    ]
    //自营税收
    optTabledata25 = [
        {
            key: 'opt_source',
            title: '税收信息',
            align: 'center'
        },
        {
            key: 'point',
            title: '税收金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //无限代佣金
    optTabledata26 = [
        {
            key: 'opt_source',
            title: '佣金信息',
            align: 'center'
        },
        {
            key: 'point',
            title: '佣金',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //每日返奖
    optTabledata27 = [
        {
            key: 'opt_detail',
            title: '返水金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        },
        // {
        //     key: 'opt_detail', title: '流水百分比', align: 'center',
        // },
        {
            key: 'opt_source',
            title: '返水信息',
            align: 'center'
        }
    ]
    //专享支付
    optTabledata28 = [
        {
            key: 'game_name',
            title: '转入方式',
            align: 'center',
            render: (h, params) => {
                return h('span', '专享支付')
            }
        },
        {
            key: 'point',
            title: '转入金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //转入返利
    optTabledata30 = [
        {
            key: 'opt_detail',
            title: '获取方式',
            align: 'center'
        },
        {
            key: 'point',
            title: '返利金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //自动彩金赠送
    optTabledata31 = [
        {
            key: 'opt_source',
            title: '赠送方式',
            align: 'center'
        },
        {
            key: 'point',
            title: '赠送金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //合服赠送金额
    optTabledata32 = [
        // {
        //     key:'opt_detail', title:'合服盘口', align: 'center',
        // },
        {
            key: 'point',
            title: '返利金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //转运金赠送
    optTabledata33 = [
        {
            key: 'time',
            title: '赠送时间',
            align: 'center'
        },
        {
            key: 'point',
            title: '转运金赠送金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //合服老金额
    optTabledata34 = [
        // {
        //     key:'opt_detail', title:'合服盘口', align: 'center',
        // },
        {
            key: 'point',
            title: '赠送金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //赠送红包金额
    optTabledata35 = [
        {
            key: 'opt_source',
            title: '赠送类型',
            align: 'center'
        },
        {
            key: 'point',
            title: '赠送金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //VIP等级返利
    optTabledata36 = [
        {
            key: 'opt_source',
            title: '详细信息',
            align: 'center'
        },
        {
            key: 'point',
            title: '赠送金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]

    //每日转入红包
    optTabledata37 = [
        // {
        //     key: 'opt_source', title: '详细信息', align: 'center',
        // },
        {
            key: 'opt_detail',
            title: '赠送金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //每日礼金赠送
    optTabledata38 = [
        {
            key: 'point',
            title: '赠送金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        }
    ]
    //保险金购买
    optTabledata42 = [
        {
            key: 'point',
            title: '购买金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(Math.abs(params.row.chang_point))
                return h('span', str)
            }
        },
        {
            key: 'opt_source',
            title: '信息',
            align: 'center'
        }
    ]
    //保险金赔付
    optTabledata43 = [
        {
            key: 'point',
            title: '赔付金额',
            align: 'center',
            render: (h, params) => {
                let str = (this as any).getMoney(params.row.chang_point)
                return h('span', str)
            }
        },
        {
            key: 'opt_source',
            title: '详细信息',
            align: 'center'
        }
    ]
    getColumn() {
        switch (this.valueType) {
            case 1:
            case 2:
                return this.optTabledata2 //  1注册赠送、2绑定手机赠送
            // break;
            case 5:
            case 7:
            case 21:
                return this.optTabledata2 // 5公司入账、7银行卡转入、21（未知）
            // break;
            case 6:
                return this.optTabledata6 // 6线上转入
            // break;
            case 8:
                return this.optTabledata8 // 8管理后台赠送
            // break;
            case 9:
            case 10:
                return this.optTabledata9 // 代理业绩佣金（未知9、10）
            // break;
            case 11:
                return this.optTabledata11 // 11拒绝转出返回
            // break;
            case 12:
                return this.optTabledata12 // 12转出
            case 13:
            case 14:
                return this.optTabledata13 // 13金币兑入与兑出
            // break;
            case 17:
            case 18:
                return this.optTabledata17 // 17存入银行18银行取出
            // break;
            case 20:
                return this.optTabledata20 // 20税收返佣
            // break;optTabledata22
            case 22:
                return this.optTabledata22 // 活动奖励
            case 23:
                return this.optTabledata23 // 彩池中奖获得
            case 24:
                return this.optTabledata24 // 牌局取消退回
            case 26:
                return this.optTabledata26 // 无限代佣金
            case 27:
                return this.optTabledata27 //每日返奖
            case 28:
                return this.optTabledata28 //每日返奖
            case 29:
                return this.optTabledata29 // 29任务奖励
            case 30:
                return this.optTabledata30 //转入返利
            case 31:
                return this.optTabledata31 //自动彩金赠送
            case 32:
                return this.optTabledata32 //自动彩金赠送
            case 33:
                return this.optTabledata33 //自动彩金赠送
            case 32:
                return this.optTabledata32 //自动彩金赠送
            case 34:
                return this.optTabledata34 //合服老金额
            case 35:
                return this.optTabledata35 //赠送红包金额
            case 36:
                return this.optTabledata36 //VIP等级返利
            case 37:
                return this.optTabledata37 //每日转入红包
            case 38:
                return this.optTabledata38 //每日礼金赠送
            case 42:
                return this.optTabledata42 //每日礼金赠送
            case 43:
                return this.optTabledata43 //每日礼金赠送
            default:
                break
        }
    }

    @Prop()
    valueType

    @Prop()
    listdata
}
